import { useEffect, useState } from 'react';
import TagManager, { DataLayerArgs } from 'react-gtm-module';
import { getProfile } from '../../api/auth';
import { postWithdraw } from '../../api/login';
import { getAccumulations } from '../../api/profile';
import { useAppContext } from '../../components/provider/AppProvider';
import '../../css/Member.css';
import { sendSetAppsflyerEvent } from '../../js/postMessage';
import { plusComma } from '../../js/script';

export default function WithdrawalThree({ selectReason, detailReason, setText }: any) {
  const [coin, setCoin] = useState();
  const [userData, setUserData] = useState<any>([]);
  const [totalAmt, setTotalAmt] = useState<number>(0);
  const { isAppView } = useAppContext();

  useEffect(() => {
    getProfile()
      .then((res) => {
        const imageUrl = JSON.parse(res.data.additionalInfo);
        setCoin(imageUrl.totalCoin);
        setUserData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    getAccumulations('ADD').then((res) => {
      setTotalAmt(res.data.totalAmt);
    });
  }, []);

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <>
      <div className="withdrawal_wrap step3">
        <div className="notice_txf">
          <div className="tit_box">
            <h3>
              삭제된 데이터는 복구 불가합니다. <br />
              데이터를 모두 삭제하시겠습니까?
            </h3>
            <p>※ 계정 삭제 후 7일간 재가입이 불가능합니다</p>
          </div>
          <div className="info_box">
            <strong>삭제되는 항목</strong>
            <div className="txt">
              <p>
                아이디, 닉네임, 프로필사진, 코인/적립금 내역, 서비스 참여기록(게시글/댓글의 경우 이용약관에 따라
                유지됩니다.)
              </p>
              <p>연락처의 경우 부정 재가입 방지를 위해 탈퇴일로부터 한달간 보관 후 파기합니다.</p>
            </div>
            <strong>보유 코인/적립금</strong>
            <div>
              <dl>
                <dt>피싱코인</dt>
                <dd>{plusComma(coin)}코인</dd>
              </dl>
              <dl>
                <dt>적립금</dt>
                <dd>{plusComma(totalAmt)}원</dd>
              </dl>
            </div>
          </div>
        </div>
        <div className="btn_box">
          <button
            onClick={() => {
              postWithdraw(userData.memberId, selectReason, detailReason)
                .then((res) => {
                  if (res.data.message === 'ok') {
                    alert('회원탈퇴 되었습니다.');
                    const viewItem: DataLayerArgs = {
                      dataLayer: {
                        event: 'delete_account',
                        event_info: {
                          delete_reason: selectReason,
                        },
                      },
                    };
                    if (isAppView) {
                      sendSetAppsflyerEvent({
                        eventName: 'delete_account',
                        eventType: {
                          delete_reason: selectReason,
                        },
                      });
                    } else {
                      TagManager.dataLayer(viewItem);
                    }
                  }
                  setText('four');
                })
                .catch((err) => {
                  alert('다시 시도해주세요');
                });
            }}
          >
            네, 삭제할게요
          </button>
        </div>
      </div>
    </>
  );
}
